import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from '../../i18n';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Company Info and Brand */}
          <div className="footer-brand">
            <h3 className="footer-title">SecurePaper</h3>
            <p className="footer-tagline">
              {t('footer.tagline')}
            </p>
            {/* <div className="footer-social">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
            </div> */}
          </div>
          
          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-heading">{t('footer.quickLinks')}</h4>
            <ul className="footer-list">
              <li><Link to="/">{t('footer.home')}</Link></li>
              <li><Link to="/create_encrypted_text">{t('footer.createPaper')}</Link></li>
              <li><Link to="/messages">{t('footer.myPapers')}</Link></li>
              <li><Link to="/keys">{t('footer.myKeys')}</Link></li>
            </ul>
          </div>
          
          {/* About & Legal */}
          <div className="footer-links">
            <h4 className="footer-heading">{t('footer.information')}</h4>
            <ul className="footer-list">
              <li><Link to="/security">{t('footer.securityModel')}</Link></li>
              <li><Link to="/privacy">{t('footer.privacyPolicy')}</Link></li>
              <li><Link to="/terms">{t('footer.terms')}</Link></li>
              <li><a href="mailto:support@securepaper.app">{t('footer.contact')}</a></li>
              <li><Link to="/info">{t('footer.howItWorks')}</Link></li>
              <li><a href="/offline-decryptor.html" download>{t('footer.offlineDecryptor')}</a></li>
              <li><a href="https://securepaper.app">{t('footer.website')}</a></li>
            </ul>
          </div>
        </div>
        
        {/* Divider */}
        <hr className="footer-divider" />
        
        {/* Copyright */}
        <div className="footer-bottom">
          <p className="copyright">
            {t('footer.copyright', { year: currentYear })}
          </p>
          <p className="footer-disclaimer">
            {t('footer.disclaimer')} <Link to="/security">{t('footer.seeHow')}</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
